import { ORDER_APIS } from "@/api_framework/api_config";
import { IOrderManagementFilterBody, IOrderManagementOrderListResponse } from "@/api_framework/api_modals/Orders";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useAPIUtils } from "../../useAPIUtils";
import { useConfiguration } from "../../useConfiguration";

type IQCUpdateAPIResponse = {
  status: boolean;
  message: any;
};

AxiosCurlirize(axios, () => {});

export const useOrderListAlertAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();

  const execute = useCallback(
    async (filterBody: IOrderManagementFilterBody): Promise<IQCUpdateAPIResponse | undefined> => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const response = await axios.post<IOrderManagementOrderListResponse>(
          ORDER_APIS?.ORDER_LIST?.baseURL ?? "",
          filterBody,
          {
            headers: {
              Authorization: accessToken ?? "",
              "Content-Type": "application/json",
            },
          },
        );

        if (response.data.status) {
          return {
            status: true,
            message: response.data.data,
          };
        }

        return {
          status: false,
          message: "No data found",
        };
      } catch (error: any) {
        if (axios.isAxiosError(error)) {
          sendCurl(error.config?.["curlCommand"]);
          // captureError(error);
        }

        // toast.error("Server Error: " + error.message);

        return {
          status: false,
          message: "Server error",
        };
      }
    },
    [configuration, sendCurl, captureError],
  );

  return { execute };
};
